import type { DashboardConfig } from '../config';
import { clusterBase } from '../clusterBase';

/*
 * "Le Grand Jeu Monopoly — Carrefour France" (08 Sep – 12 Oct 2026, 5 weeks).
 * A realtime campaign dashboard with its own payload shape (cards, dice, board
 * laps, street collections, digital packs by channel), so `kind: 'monopoly'`
 * renders features/monopoly rather than the shared Carrefour dashboard.
 *
 * Step 1 = this UI, rendering from the design fixture in dev until the
 * pipeline exists. A deployed build falls back to zeros (MONOPOLY_EMPTY) and
 * says "Sample data" in the header — never invented figures.
 */
export const monopolyConfig: DashboardConfig = {
  path: '/carrefour/monopoly-2026',
  reportId: 'carrefour-monopoly-2026',
  label: 'France · Monopoly 2026',
  endsOn: '2026-10-12', // 8 Sep → 12 Oct — archived from the day after
  kind: 'monopoly',
  apiBaseUrl: clusterBase('eu'),
  hasExport: true,
};
